'use client';

import ROUTES from '@lib/constants/routes';
import { usePathname } from 'next/navigation';
import style from '../NewsListWrapper/NewsListWrapper.module.scss';

const newsRoot = ROUTES.news.root.replace(/\/+$/, '');

export function NewsListHeading() {
  const pathname = usePathname();
  const normalized = pathname?.replace(/\/+$/, '') || '/';
  const isSlugRoute = normalized.startsWith(`${newsRoot}/`) && normalized !== newsRoot;
  const Tag = isSlugRoute ? 'h2' : 'h1';

  return (
    <Tag className={style.title} itemProp='name'>
      Новости
    </Tag>
  );
}
